<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';
// BonBoZ: mẫu trả lời theo trang — mẫu không gán trang nào là mẫu chung, mẫu
// có gán thì chỉ trang đó thấy. Danh sách gán nằm ở cấu hình theo trang, không
// phải cột trong `canned_responses`.
import { loadPageConfigs, locMauTheoTrang } from 'dashboard/helper/pageConfig';
// BonBoZ: mau nhieu tin + doi #SEX{...} theo gioi tinh khach, xem mauNhieuTin.js.
import { noiDungMau, nguCanhChen } from 'dashboard/helper/bonboz/mauNhieuTin';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  // BonBoZ: `anh` di kem `replace` — mau co anh thi chen ca chu lan anh.
  emits: ['replace', 'anh'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
      currentChat: 'getSelectedChat',
      currentUser: 'getCurrentUser',
    }),
    items() {
      // BonBoZ: lọc theo trang của hội thoại đang mở. Chưa nạp được cấu hình
      // -> hiện tất cả mẫu, mất bộ lọc chứ không mất chức năng chèn mẫu.
      const hien = locMauTheoTrang(
        this.cannedMessages,
        this.currentChat?.inbox_id
      );
      const nguCanh = nguCanhChen(
        this.$store.getters['contacts/getContact'](
          this.currentChat?.meta?.sender?.id
        ),
        this.currentUser
      );
      return hien.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: noiDungMau(cannedMessage, nguCanh),
        mau: cannedMessage,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
    loadPageConfigs(); // BonBoZ: bản đồ dùng chung cả app
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
      if (item.mau?.anh_ids?.length) this.$emit('anh', item.mau);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
